import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import api from '../../api';
import { Sun, Moon } from 'lucide-react';

export default function Profile() {
  const navigate = useNavigate();
  const { user, updateUser } = useAuth();
  const [uploading, setUploading] = useState(false);
  const [profileImage, setProfileImage] = useState(user?.profile_image || null);
  const [togglingTheme, setTogglingTheme] = useState(false);
  const fileInputRef = useRef(null);

  const isVendedor = user?.business_type === 'Vendedor';

  const handleImageClick = () => { fileInputRef.current?.click(); };

  const handleImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) { alert('Por favor selecciona una imagen válida'); return; }
    if (file.size > 5 * 1024 * 1024) { alert('La imagen debe ser menor a 5MB'); return; }
    setUploading(true);
    try {
      const reader = new FileReader();
      reader.onload = async (event) => {
        const base64Image = event.target.result;
        await api.put(`/business/users/${user.id}`, { profile_image: base64Image });
        setProfileImage(base64Image);
        updateUser({ profile_image: base64Image });
        alert('Imagen actualizada correctamente');
        setUploading(false);
      };
      reader.readAsDataURL(file);
    } catch {
      alert('Error al subir la imagen');
      setUploading(false);
    }
  };

  const handleThemeToggle = async () => {
    const newTheme = user.theme === 'estetica' ? 'barberia' : 'estetica';
    setTogglingTheme(true);
    try {
      await api.put(`/business/users/${user.id}`, { theme: newTheme });
      updateUser({ theme: newTheme });
      document.body.className = newTheme === 'estetica' ? 'theme-estetica' : '';
    } catch { alert('Error al cambiar el tema'); }
    finally { setTogglingTheme(false); }
  };

  return (
    <div className="page-full">
      <div className="header">
        <button className="icon-btn" data-testid="back-btn" onClick={() => navigate(-1)}>←</button>
        <h1 className="header-title">Perfil</h1>
      </div>
      <div className="content-scroll">
        <div style={{ textAlign: 'center', marginBottom: '28px', marginTop: '16px' }}>
          <input type="file" ref={fileInputRef} onChange={handleImageChange} accept="image/*" style={{ display: 'none' }} />
          <div onClick={handleImageClick} style={{ cursor: 'pointer', position: 'relative', display: 'inline-block' }} data-testid="profile-image-upload">
            {profileImage ? (
              <img src={profileImage} alt="" className="profile-image" />
            ) : (
              <div className="profile-placeholder">👤</div>
            )}
            <div style={{ position: 'absolute', bottom: '5px', right: '5px', background: 'var(--accent)', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', border: '2px solid var(--surface)' }}>📷</div>
          </div>
          <p className="card-row-detail" style={{ marginTop: '12px' }}>{uploading ? 'Subiendo imagen...' : 'Toca la imagen para cambiarla'}</p>
        </div>

        <div className="info-card">
          <div className="info-row"><span className="info-icon">🏢</span><div><div className="info-label">Nombre del Negocio</div><div className="info-value">{user?.business_name}</div></div></div>
          <div className="info-row"><span className="info-icon">🏷️</span><div><div className="info-label">Tipo de Perfil</div><div className="info-value">{user?.business_type}</div></div></div>
          <div className="info-row" style={{ borderBottom: 'none' }}><span className="info-icon">👤</span><div><div className="info-label">Usuario</div><div className="info-value">{user?.username}</div></div></div>
        </div>

        {/* Theme toggle — only for Vendedor */}
        {isVendedor && (
          <div className="info-card" style={{ flexDirection: 'row', alignItems: 'center', gap: '14px', cursor: 'pointer' }} onClick={handleThemeToggle} data-testid="theme-toggle">
            <span>{user?.theme === 'estetica' ? <Sun size={22} color="var(--accent)" /> : <Moon size={22} color="var(--accent)" />}</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700 }}>Tema de la App</div>
              <div className="card-row-detail">{user?.theme === 'estetica' ? 'Tema Claro (Estética)' : 'Tema Oscuro (Barbería)'} — Tocá para cambiar</div>
            </div>
            {togglingTheme && <div className="spinner" style={{ width: 20, height: 20 }} />}
          </div>
        )}

        <div className="info-card" style={{ flexDirection: 'row', alignItems: 'flex-start', gap: '12px' }}>
          <span>ℹ️</span>
          <p className="card-row-detail" style={{ flex: 1, lineHeight: '20px' }}>Tu imagen de perfil se mostrará en el dashboard y en tu catálogo. Para cambiar otros datos, contactá al administrador.</p>
        </div>
        <div className="info-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}><span>💬</span><strong>Contactate con nosotros</strong></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span>📧</span><span className="accent-text" style={{ fontWeight: '600' }}>tukinegociosapp@gmail.com</span></div>
        </div>
        <div className="info-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/privacy-policy')} data-testid="privacy-policy-link">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><span>🔒</span><strong>Política de Privacidad</strong></div>
            <span style={{ color: 'var(--text2)' }}>→</span>
          </div>
        </div>
      </div>
    </div>
  );
}
